import { useAppSelector } from '../../../Hooks/useAppSelector'
import { LabsSelectors } from '../StoreAdapter'

export const useLabsSelector = () => {
  return useAppSelector(LabsSelectors.selectEntities)
}
